module.exports = __webpack_public_path__ + "media/images/publication_database-3eae1c7989b72a6b30abeab29f421ae8.jpg";